import { render, staticRenderFns } from "./onlineDataWater3.vue?vue&type=template&id=538b3915&scoped=true&"
import script from "./onlineDataWater3.vue?vue&type=script&lang=js&"
export * from "./onlineDataWater3.vue?vue&type=script&lang=js&"
import style0 from "./onlineDataWater3.vue?vue&type=style&index=0&id=538b3915&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538b3915",
  null
  
)

export default component.exports